import { ApiResponse } from 'apisauce';

import { GatewayResponse } from 'api/types/types';

import { OutletListingItem } from 'redux/slices/profile/types';
import { GetUserInfoAPIParams } from './ProfileBase';

import Utils from './types/Utils';
import { IOutletGateway } from './OutletBase';

const { getHeaders } = Utils;

export default class OutletGateway extends IOutletGateway {
    async getOutletListing(params: GetUserInfoAPIParams): GatewayResponse<OutletListingItem[]> {
        const { authToken } = params;
        const response: ApiResponse<OutletListingItem[]> = await this.api.get('/customer/outletListing', {}, getHeaders(authToken));
        return this.process(response);
    }
}
